import { useState } from "react";
import { Button, Card, CardBody } from "../../../components/ui";
import { CheckBox } from "../../../components/ui/inputs";
import localization from "../../../config/localization";
import { ConfirmationModal } from "../../../components/ui/modals/ConfirmationModal";
import { localStorageService } from "../../../services";
import { FeedbackModal as SuccessModal } from "../../../components/ui/modals/FeedbackModal";
import { useNavigate } from "react-router-dom";
import { responsibleGamingService } from "../service/responsibleGaming.service";
import { toastService as toast } from "../../../components/ui/toast/toast.service";
import userDeviceStore from "../../../store/device.store";
import { DeviceType } from "../../../models/constants/deviceType";

export function SelfExclusion() {
  const [isSelfExclude, setIsSelfExclude] = useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const navigate = useNavigate();
  const deviceType = userDeviceStore((state) => state.deviceType);

  const handleSelfExclude = async () => {
    const response = await responsibleGamingService.selfExclude({
      id: localStorageService.getItem<string>("userId"),
      isSelfExclude: isSelfExclude,
    });
    var message = localization.getString(response.message)
    if (response.isSuccess) {
      toast.success(message);
      setIsConfirmationModalOpen(false);
      setIsSuccessModalOpen(true);

      setTimeout(() => {
        localStorageService.clear();
        navigate("/");
        window.location.reload();
      }, 3000);
    } else {
      toast.error(message);
    }
  };

  const content = (
    <div className="px-4 pb-6">
      <div className="border border-[#333] rounded-lg p-4 bg-black mt-10">
        <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-white">
          <img src={"/icons/ic-info.svg"} alt="Take a Break" className="w-8 h-8" />
        </div>

        <p className="mt-4  text-gray-300 leading-relaxed text-justify">
          {localization.selfexclusionnotes}
        </p>
      </div>

      <div className="mt-6">
        <CheckBox
          label={localization.selfexclusionlabel}
          labelClassName="text-[#A9A9A9]"
          checked={isSelfExclude}
          onChange={() => setIsSelfExclude(!isSelfExclude)}
        />
      </div>

      <div className="flex justify-center">
        <Button
          type="submit"
          className={`mt-2 w-full md:w-1/3 py-4 rounded-md bg-primary-gradient text-white font-semibold tracking-wide ${!isSelfExclude ? "opacity-50 cursor-not-allowed" : "hover:bg-primary-gradient/80 cursor-pointer"}`}
          onClick={() => setIsConfirmationModalOpen(true)}
          disabled={!isSelfExclude}
        >
          {localization.submit.toUpperCase()}
        </Button>
      </div>

      {isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={isConfirmationModalOpen}
          onConfirm={() => handleSelfExclude()}
          title={localization.selfexcludeconfirmationlabel1}
          description={localization.selfexcludeconfirmationlabel2}
          descriptionClassName="text-[#A51C1B] font-semibold"
          icon={"/icons/ic-info.svg"}
          blurColor="bg-[#FFE6CC]"
          confirmText="Yes"
          cancelText="No"
          onCancel={() => setIsConfirmationModalOpen(false)}
        />
      )}

      {isSuccessModalOpen && (
        <SuccessModal
          isOpen={isSuccessModalOpen}
          icon={"/icons/ic-success-modal.svg"}
          onClose={() => setIsSuccessModalOpen(false)}
          title={localization.selfexclusionsuccesslabel}
          blurColor="bg-[#D4FFDECC]"
        />
      )}
    </div>
  )

  return (
    deviceType !== DeviceType.Web ? content : (
      <Card>
        <CardBody showGradient>
          <div className="w-full max-w-5xl mx-auto">
            {content}
          </div>
        </CardBody>
      </Card>
    )
  );
}
